import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { getQueryParamValue } from "@chatfood/core-utils";
import { useOutletStore, type IDomainOrderingMode } from "#imports";
import { useNavigation } from "~/composables/use-navigation";

export default defineNuxtRouteMiddleware((to, _from) => {
  const outlet = useOutletStore();
  const menus = outlet.orderingMode.menus;
  const orderingMode = getQueryParamValue(
    to.params,
    "orderingMode",
  ) as IDomainOrderingMode;
  const outletSlug = getQueryParamValue(to.params, "outletSlug");

  if (menus.length !== 1 || !orderingMode || !outletSlug) return;

  const { resolvePath } = useNavigation();
  const toRoute = resolvePath("menu", {
    menuSlug: menus[0].slug,
    orderingMode,
    outletSlug,
  });

  if (to.path === toRoute) return;
  return navigateTo(toRoute, { replace: true });
});
